/*
This file is located in the main branch
Last time the file was updated (UTC): [06.12.2023 15:23:16]
Permissions to update outside the main branch: [false]
*/

import { AxiosInstance } from 'axios';
import { HistTableInfoData } from 'models/api/histTable';

export const getHistTable = async (axios: AxiosInstance) => {
    const response = await axios.get<HistTableInfoData>('/histTable');
    return response.data;
};

export const setHasHist = async (axios: AxiosInstance, schemaName: string, tableName: string) => {
    return await axios.post<HistTableInfoData>(`/histTable/${schemaName}.${tableName}`);
};
